<template>
  <div class="upload-file">
    <div v-if="isAllow || delFlag" class="uploadbox">
      <div class="upload" @click="open()">
        <i class="el-icon-upload"></i>
        <p>上传</p>
      </div>
    </div>
    <draggable v-if="file_list.length>0" :list="file_list" :options="{disabled:disabled,animation:120}" class="file_list" @update="checkMove">
      <div v-for="(item,index) in file_list" :key="index" :style="{'cursor':!disabled? 'move':''}" class="uploadbox">
        <div class="upload">
          <img :src="BASE_CDN_API+item.file_url" :onerror="fileimg[index]" alt="点击查看" />
          <!-- <img :src="item" :onerror="errorImg" alt="点击查看" /> -->
          <div class="layer">
            <!-- <a target="view_window" :href="item"> -->
            <a :href="returnLink(BASE_CDN_API+item.file_url)" target="view_window">
              <i class="el-icon-zoom-in"></i>
            </a>
            <a v-if="returnLink(BASE_CDN_API+item.file_url).indexOf('https://view.officeapps')>=0" :href="BASE_CDN_API+item.file_url" target="view_window" download>
              <i class="el-icon-download"></i>
            </a>
            <i v-if="isAllow || (delFlag && item.is_approve_end_up===1)" class="el-icon-delete" @click="deleteimg(index,item)"></i>
          </div>
        </div>
        <el-tooltip v-if="item.file_name" :content="item.file_name" class="item" effect="dark" placement="bottom">
          <span class="filename">{{ item.file_name }}</span>
        </el-tooltip>
        <slot :SlotsData="item" name="UploadFileSlots"></slot>
      </div>
    </draggable>

    <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" title="上传">
      <dropzone v-if="dialogFormVisible" :id="id" :thumbnail-height="100" :accepted-files="acceptedFiles" :thumbnail-width="100" :max-files="maxFiles" default-msg="上传文件" @dropzone-removedFile="dropzoneR" @dropzone-success="dropzoneS" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false;upload_list=[]">取消</el-button>
        <el-button v-if="isSave" type="primary" @click="confirm()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Dropzone from '@/components/Dropzone'
import errorimage from '@/assets/word/word.png'
import pdf from '@/assets/word/pdf.png'
import doc from '@/assets/word/doc.png'
import excel from '@/assets/word/excel.png'
export default {
  name: 'Uploadfile',
  components: { Dropzone, draggable },
  props: {
    id: {
      type: String, // id
      default: 'myVueDropzone'
    },
    files: {
      type: [String, Array], // 文件列表
      default: ''
    },
    filenames: {
      type: String, // 文件名称
      default: ''
    },
    maxFiles: {
      type: Number, // 最大上传数
      required: true
    },
    acceptedFiles: {
      type: String, // 可接受文件类型
      default: '.jpg,.gif,.png,.pdf,.xls,.doc,.docx,.xlsx,.csv'
    },
    disabled: {
      type: Boolean, // 是否可以拖拽排序 true 不开启  false 开启
      default: false
    },
    isAllow: {
      type: Boolean, // 是否允许上传
      default: true
    },
    version: {
      type: Number,
      default: 1
    },
    delFlag: {
      type: Number,
      default: 0
    },
    // 删除已上传文件前是否二次确认
    needConfirmDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      BASE_CDN_API: process.env.BASE_CDN_API,
      dialogFormVisible: false,
      errorImg: 'this.src="' + errorimage + '"',
      file_list: [],
      isSave: false,
      fileimg: [],
      upload_list: []
    }
  },
  computed: {},
  watch: {
    files: {
      handler: function(newVal, oldVal) {
        this.dataIntegrate()
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.dataIntegrate()
  },
  mounted: function() {
    this.dataIntegrate()
  },
  methods: {
    dataIntegrate() {
      this.$nextTick(() => {
        // 数据整合
        // version=1 按原逻辑组合成file_list
        // version=2 file_list 等于 files
        if (this.version == 1) {
          if (this.files == '' || !this.files) {
            this.file_list = []
          } else {
            const files = this.files.split(',')
            const file_names = this.filenames.split(',')
            const file_list = []
            files.forEach((element, index) => {
              const item = {}
              item.file_url = element
              item.file_name = file_names[index]
              file_list.push(item)
            })
            this.file_list = file_list
          }
        } else if (this.version == 2) {
          this.file_list = this.files || []
        }
        this.extname(this.file_list)
      })
    },
    // 上传文件
    dropzoneS(file) {
      this.isSave = true
      const item = {}
      item.file_url = JSON.parse(file.xhr.response).File
      item.file_name = file.name
      item.file_size = file.size || 0
      item.upload_time = this.formatUploadTime(new Date())
      item.file_type = this.returnDocFormat(JSON.parse(file.xhr.response).File)
      if (this.delFlag === 1) {
        item.is_approve_end_up = 1
      }
      this.upload_list.push(item)
    },
    formatUploadTime(d) {
      const pad = n => (n < 10 ? '0' + n : '' + n)
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
        ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
    },
    dropzoneR(file) {},
    deleteimg(i, item) {
      const doDelete = () => {
        this.file_list.splice(i, 1)
        this.extname(this.file_list)
        this.returnFileList()
        this.$emit('deleteFile', item)
      }
      if (!this.needConfirmDelete) {
        doDelete()
        return
      }
      const name = (item && item.file_name) ? item.file_name : '该文件'
      this.$confirm(`确认删除文件「${name}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        doDelete()
      }).catch(() => {})
    },
    confirm() {
      if (this.maxFiles == 1) {
        this.file_list = []
      }
      if (this.file_list.length + this.upload_list.length > this.maxFiles) {
        this.$message({
          type: 'warning',
          message: '超过上传数最大值'
        })
        this.dialogFormVisible = false
        this.upload_list = []
        return false
      }
      this.file_list = this.file_list.concat(this.upload_list)
      this.extname(this.file_list)
      this.returnFileList()
      this.dialogFormVisible = false
      this.upload_list = []
    },
    open() {
      if (
        this.file_list.length + this.upload_list.length >= this.maxFiles &&
        this.maxFiles !== 1
      ) {
        this.$message({
          type: 'warning',
          message: '超过上传数最大值'
        })
        return false
      }
      this.dialogFormVisible = true
      this.isSave = false
    },
    checkMove(e) {
      this.returnFileList()
    },
    // 获取后缀名
    extname(list) {
      const fileimg = []
      const typeList = []
      list.forEach(filename => {
        const b = this.returnDocFormat(filename.file_url)
        if (b == 'pdf') {
          fileimg.push('this.src="' + pdf + '"')
        } else if (b == 'xls' || b == 'xlsx') {
          fileimg.push('this.src="' + excel + '"')
        } else if (b == 'doc' || b == 'docx') {
          fileimg.push('this.src="' + doc + '"')
        } else {
          fileimg.push('this.src="' + errorimage + '"')
        }
        typeList.push(b)
      })
      this.fileimg = fileimg
    },
    returnDocFormat(i) {
      const a = i
        .split('')
        .reverse()
        .join('')
      const b = a
        .substring(0, a.search(/\./))
        .split('')
        .reverse()
        .join('')
      return b
    },
    returnLink(item) {
      const a = item
        .split('')
        .reverse()
        .join('')
      const b = a
        .substring(0, a.search(/\./))
        .split('')
        .reverse()
        .join('')
      const file_type = [
        'csv',
        'doc',
        'docx',
        'odp',
        'ods',
        'odt',
        'pot',
        'potm',
        'potx',
        'pps',
        'ppsx',
        'ppsxm',
        'ppt',
        'pptm',
        'pptx',
        'rtf',
        'xls',
        'xlsx'
      ]
      if (file_type.indexOf(b) >= 0) {
        return 'https://view.officeapps.live.com/op/view.aspx?src=' + item
      } else {
        return item
      }
    },
    returnFileList() {
      const fileUrl = []
      const fileName = []
      this.file_list.forEach(element => {
        fileUrl.push(element.file_url)
        fileName.push(element.file_name)
      })
      this.$emit('changeFile', fileUrl.join(','))
      this.$emit('changeFileName', fileName.join(','))
      this.$emit('changeFileList', this.file_list)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.upload-file {
  display: flex;
  align-items: flex-start;
}
.file_list {
  display: flex;
  flex-wrap: wrap;
}
.uploadbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  margin: 0 10px 0 0;
  color: #42b983;
  .filename {
    width: 100px;
    text-align: center;
    overflow: hidden;
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.upload {
  width: 100px;
  height: 100px;
  border: 1px dashed;
  display: flex;
  justify-content: center;
  align-self: center;
  flex-direction: column;
  color: #42b983;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  margin: 6px 6px 6px 0;
  border-radius: 5px;
  padding: 0;
  float: left;
  cursor: pointer;
  i {
    font-size: 1.5em;
    text-align: center;
  }
  p {
    text-align: center;
    font-size: 0.5em;
    margin: 0;
  }
  img {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    width: 90px;
    display: block;
  }
  .layer {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    transition-property: background 0.3s ease-out 0s;
    /* Firefox 4 */
    -moz-transition: background 0.3s ease-out 0s;
    /* Safari and Chrome */
    -webkit-transition: background 0.3s ease-out 0s;
    /* Opera */
    -o-transition: background 0.3s ease-out 0s;
    i {
      display: none;
    }
  }
  .layer:hover {
    background: rgba($color: #000000, $alpha: 0.4);
    color: white;
    display: flex;
    justify-content: space-around;
    align-items: center;
    i {
      display: block;
    }
  }
}
</style>
